import { render, staticRenderFns } from "./AFormGeneral.vue?vue&type=template&id=5001f6f4&scoped=true&"
import script from "./AFormGeneral.vue?vue&type=script&lang=js&"
export * from "./AFormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5001f6f4",
  null
  
)

export default component.exports